import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";

import ActionContainer from "../containers/actionContainer";
import Guard from "../containers/guard";
import InputCard from "../../../components/stepOne/inputCard";

import {
  validBalance,
  addCard,
} from "../../../utils/validators/stepOneSell_v2";

import {
  cartIsEmptySelector,
  cartSelector,
  cardsSelector,
  cardPartialSelector,
} from "../../../selectors";

export default () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { config, cartSell, cards, cardPartial, cartIsEmpty } = useSelector(
    (state) => ({
      config: state.config,
      cartSell: cartSelector(state),
      cards: cardsSelector(state),
      cardPartial: cardPartialSelector(state),
      cartIsEmpty: cartIsEmptySelector(state),
    }),
    shallowEqual
  );

  const submitCard = () => {
    setIsSubmitting(true);
    addCard(cartSell, cardPartial, cards, dispatch, () =>
      validBalance(cardPartial, dispatch)
    );

    if (cartSell.cardIds.length) {
      history.push("/sounds-good");
    } else {
      setIsSubmitting(false);
    }
  };

  const submitBtnDisabled =
    isSubmitting ||
    (cardPartial.balance === "" && cardPartial.selectedMerchant === null);

  const submitBtnClasses = !submitBtnDisabled
    ? "btn btn-primary activebtn"
    : "btn btn-primary";

  return (
    <Guard condition={!cartIsEmpty} redirect={"/sounds-good"}>
      <ActionContainer title={config.offerTitle} scrollable={false}>
        <React.Fragment>
          <InputCard
            offerMerchantDropDownPlaceHolder={
              config.offerMerchantDropDownPlaceHolder
            }
            offerBalanceInputPlaceHolder={config.offerBalanceInputPlaceHolder}
            cardPartial={cardPartial}
            layoutVersion={config.layoutVersion}
          />
        </React.Fragment>
        <React.Fragment>
          <input
            type="button"
            onClick={submitCard}
            name="submit"
            className={submitBtnClasses}
            value={
              cartIsEmpty ? config.offerButtonTxt : config.offerButtonTxtMany
            }
            disabled={submitBtnDisabled}
          />
        </React.Fragment>
      </ActionContainer>
    </Guard>
  );
};
